//Action Types
export var POS_RESET_ACTION_TYPE = "pos/reset";
export var POS_CREATE_REQUEST_START_ACTION_TYPE = "pos/create_request_start";
export var POS_CREATE_REQUEST_SUCCESS_ACTION_TYPE = "pos/create_request_success";
export var POS_CREATE_DEPOSIT_REQUEST_START_ACTION_TYPE = "pos/create_deposit_request_start";
export var POS_CREATE_DEPOSIT_REQUEST_SUCCESS_ACTION_TYPE = "pos/create_deposit_request_success";
export var POS_CANCEL_START_ACTION_TYPE = "pos/cancel_start";
export var POS_CANCEL_SUCCESS_ACTION_TYPE = "pos/cancel_success";
export var POS_ERROR_ACTION_TYPE = "pos/error";
